import Statistic from './container'

export default Statistic
